import intl from 'react-intl-universal';

export function match(password: string, passwordConf: string, setError: (error: string) => void) {
  if (password !== passwordConf) {
    setError(intl.get('validation.password.passwordsDoNotMatchError'));
    return false;
  } else {
    setError('');
    return true;
  }
}

export function validate(password: string, setError: (error: string) => void) {
  if (!/^([\x21-\x7E]){8,32}$/.test(password)) {
    setError(intl.get('validation.password.passwordLengthError'));
    return false;
  }
  setError('');
  return true;
}
